import { useEffect } from 'react'

//Element ID needs to be different from Hash to prevent default browser scroll to id behavior
export const useScrollToIdIntoViewWhenHashInUrlAfterLoading = (
  hash: string,
  elementId: string,
  isLoading: boolean,
): void => {
  useEffect(() => {
    if (!isLoading && window.location.hash === hash) {
      const element = document.querySelector(elementId)
      element?.scrollIntoView()
    }
  }, [isLoading, hash, elementId])
}
